__webpack_require__.p = "https://rewards-non-prod.lorehealthcare.com/";